import { FC, lazy } from 'react';
import { useDirectFcfsFlags } from 'src/hooks/use-direct-fcfs-flags';
import { Forbidden } from 'src/utils/errors';

const Page = lazy(() => import('./page'));

export const DirectFcfs: FC = () => {
  const directFcfsFlags = useDirectFcfsFlags();
  const allowed = directFcfsFlags.data?.roles.includes('TSO_USER');
  if (!allowed) throw directFcfsFlags.error || new Forbidden();
  return <Page />;
};
